var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-tag',{attrs:{"type":_vm.typeMap[_vm.state] || 'is-dark'}},[_vm._v(_vm._s(_vm.messageMap[_vm.state] || _vm.state))])}
var staticRenderFns = []

export { render, staticRenderFns }